import {
  Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
} from '@triare/auth-redux';
import {
  put, delay, takeLatest, call,
} from 'redux-saga/effects';
import { actions, International } from './index';

export type InternationalByIdData = International

export type InternationalByIdResponse = InternationalByIdData

export interface InternationalByIdParams {
  id: string;
}

export const internationalById = (payload: InternationalByIdParams): Action<InternationalByIdParams> => ({
  type: actions.internationalByIdTrigger.toString(),
  payload,
});

export const internationalByIdClear = (): Action => ({
  type: actions.internationalByIdClear.toString(),
});

export const internationalByIdErrorClear = (): Action => ({
  type: actions.internationalByIdErrorReset.toString(),
});

export function* internationalByIdRequestSaga({ payload }: Action<InternationalByIdParams>) {
  yield put({
    type: actions.internationalByIdStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.internationalByIdError.toString(),
      payload: {
        message: 'InternationalById: Parameters not passed.',
      },
    });

    return;
  }

  const { id, ...params } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${config.api.url}internationals/${id}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        params: new URLSearchParams(params).toString(),
      },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<InternationalByIdData, InternationalByIdResponse>(
    response,
    actions.internationalByIdSuccess.toString(),
    actions.internationalByIdError.toString(),
    false,
    (internationalByIdData) => internationalByIdData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.internationalByIdTrigger.toString(),
    defaultProcessingSaga(
      internationalByIdRequestSaga,
      {
        error: actions.internationalByIdError.toString(),
        locationCancel: actions.internationalByIdClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.internationalByIdSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.internationalByIdError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.internationalByIdErrorReset.toString(),
    });
  });
}
